import React, { Component } from 'react';
import ReactSVG from 'react-svg';
import { FeatureCards, FeatureCard } from './FeatureCardsStyles';
import { features } from '../../data/features';

class FeaturesComponent extends Component {
  render() {
    return (
      <section>
        <div className="container">
          <h1>Software with Professional Guidance</h1>
          <div className="sub-header">
            Check the financial wealth of your small business anytime. A team of
            bookkeeping professionals are available to answer your questions along the
            way.
          </div>
        </div>
        <div className="container">
          <FeatureCards className="row">
            {features.map(card => (
              <FeatureCard key={card.title}>
                <div className="inner">
                  <ReactSVG src={card.icon} className="icon" />
                  <div className="text">
                    <h4>{card.title}</h4>
                    <p>{card.description}</p>
                  </div>
                </div>
              </FeatureCard>
            ))}
          </FeatureCards>
        </div>
      </section>
    );
  }
}

export default FeaturesComponent;
